var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"drawingWrapper",staticClass:"drawingWrapper",style:(_vm.styleWrapper)},[(_vm.erasing)?_c('DrawingElement',{ref:"drawing",attrs:{"id":"drawing","color":"#ccc","thickness":"3","path":_vm.path,"viewBox":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }